export default __webpack_public_path__ + "static/media/collapse_icon.ddf59664.svg";